import React from "react";
import DropdownMenu from "../../Inputs/DropdownMenu";
import { ButtonLink } from "../ButtonLink";
import { Body } from "../Typography";
import {
  CollaboratorActions,
  CollaboratorContent,
  CollaboratorRowContainer,
  CollaboratorTextContent,
} from "./__styles__/CollaboratorList";
import { Collaborator, PermissionOption } from "./types";

interface CollaboratorRowProps {
  collaborator: Collaborator;
  permissionOptions: PermissionOption[];
  onPermissionChange?: (collaboratorId: string, permission: string) => void;
  showRemoveOption?: boolean;
  onRemove?: (collaboratorId: string) => void;
  showRole?: boolean;
}

export const CollaboratorRow = ({
  collaborator,
  permissionOptions,
  onPermissionChange,
  showRemoveOption = false,
  onRemove,
  showRole = false,
}: CollaboratorRowProps) => {
  const currentPermissionLabel =
    permissionOptions.find(opt => opt.value === collaborator.permission)
      ?.label || "Can view";

  const displayLabel =
    showRole ? (collaborator.role ?? "Unknown") : currentPermissionLabel;

  const dropdownActions =
    showRemoveOption ?
      [
        {
          label: "Remove",
          onClick: () => {
            onRemove?.(collaborator.id);
          },
          variant: "red" as const,
        },
      ]
    : [
        ...permissionOptions.map(option => ({
          label: option.label,
          onClick: () => {
            onPermissionChange?.(collaborator.id, option.value);
          },
        })),
        ...(showRemoveOption ?
          [
            {
              label: "Remove",
              onClick: () => {
                onRemove?.(collaborator.id);
              },
              variant: "red" as const,
            },
          ]
        : []),
      ];

  return (
    <CollaboratorRowContainer>
      <CollaboratorContent>
        <CollaboratorTextContent>
          <Body type="emphasis" size="default" color="contentPrimary">
            {collaborator.name}
          </Body>
          {collaborator.description && (
            <Body type="regular" size="default" color="contentSecondary">
              {collaborator.description}
            </Body>
          )}
        </CollaboratorTextContent>
      </CollaboratorContent>
      <CollaboratorActions>
        <DropdownMenu
          actions={dropdownActions}
          position="below-left"
          customButton={({ onPress }) => (
            <ButtonLink
              styleVariant="primary"
              size="small"
              rightIconName="chevron-down"
              onClick={onPress}
            >
              {displayLabel}
            </ButtonLink>
          )}
        />
      </CollaboratorActions>
    </CollaboratorRowContainer>
  );
};
